import VisibilityHandler from './visibility-handler';

export default class CartPopup {
  visibilityHandler = new VisibilityHandler();

  initializeEventListeners = () => {
    this.visibilityHandler.initializeEventListeners();
  };
}
